import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsForwardIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M22.72 11.96L12.56 18.96V13L3.7 18.96V4.96L12.56 10.92V4.96L22.72 11.96ZM14.18 8.1V15.82L19.82 11.96L14.18 8.1ZM5.32 8.12V15.8L11.24 11.96L5.32 8.12Z" />
    </SvgIcon>
  );
});
